/**
 * API Configuration
 * Contains base configuration and utility functions for API calls
 */

// API base URL
export const API_BASE_URL = 'https://appotype.eu/api/v1';

// Common fetch configuration
export const DEFAULT_FETCH_CONFIG = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    mode: 'cors' as RequestMode
};

/**
 * Generic error handler for API responses
 * @param response The fetch response object
 */
export const handleApiError = async (response: Response): Promise<never> => {
    const errorData = await response.json().catch(() => ({}));
    console.error('Server error response:', errorData);
    
    if (response.status === 400) {
        throw new Error(errorData.message || 'Niepoprawne dane. Proszę sprawdzić wprowadzone informacje.');
    } else if (response.status === 401 || response.status === 403) {
        throw new Error('Brak uprawnień do wykonania tej operacji.');
    } else if (response.status === 422) {
        // For validation errors, provide more detailed information
        const errorDetails = errorData.errors ? 
            Object.entries(errorData.errors)
                .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`)
                .join('; ') : '';
        
        throw new Error(
            `Błąd walidacji danych${errorDetails ? ': ' + errorDetails : ''}. ${errorData.message || ''}`
        );
    } else if (response.status === 429) {
        throw new Error('Zbyt wiele zapytań. Proszę spróbować ponownie za chwilę.');
    } else if (response.status >= 500) {
        throw new Error('Wystąpił błąd serwera. Prosimy spróbować ponownie później.');
    } else {
        throw new Error(errorData.message || `Błąd: ${response.status}`);
    }
}; 